"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANNOUNCEMENT_ERROR_CODES = void 0;
/**
 * ORGANİZATÖR DUYURULARI HATA KODLARI (Story 1, 2, 9). `ERROR_CODES` sözlüğüne
 * yayılır; değerler anahtarla aynıdır. Ana sözlük 500 satır tavanına dayandığı
 * için ayrıldı (T2a).
 */
exports.ANNOUNCEMENT_ERROR_CODES = {
    /** Organizatör duyuruları (Story 1). Başka etkinliğin duyurusu da bu kodu alır (IDOR). */
    ANNOUNCEMENT_NOT_FOUND: 'ANNOUNCEMENT_NOT_FOUND',
    /** Seçilen küme bu etkinlikte seçilemez (erişim modu, ürün kararı, sunucu ayarı). */
    ANNOUNCEMENT_AUDIENCE_UNAVAILABLE: 'ANNOUNCEMENT_AUDIENCE_UNAVAILABLE',
    /** `promotional` türü sunucu ayarıyla kapalı (S28 cevabına kadar). */
    ANNOUNCEMENT_KIND_DISABLED: 'ANNOUNCEMENT_KIND_DISABLED',
    /** Duyuru taslak değil: düzenlenemez; iptal edilmiş duyuru gönderilemez. */
    ANNOUNCEMENT_NOT_EDITABLE: 'ANNOUNCEMENT_NOT_EDITABLE',
    /** Etkinlik yayında değil (taslak, iptal, gizli): duyuru gönderilemez. */
    ANNOUNCEMENT_EVENT_UNAVAILABLE: 'ANNOUNCEMENT_EVENT_UNAVAILABLE',
    /** Seçili kümelerde gönderim anında kimse yok. */
    ANNOUNCEMENT_NO_RECIPIENTS: 'ANNOUNCEMENT_NO_RECIPIENTS',
    /** Story 9: kurum pencere içinde 10 gönderime ulaştı (429). */
    ANNOUNCEMENT_DAILY_LIMIT: 'ANNOUNCEMENT_DAILY_LIMIT',
    /** Story 9: aynı etkinlik ve kümeye pencere içinde 2 elle duyuru gitti (429). */
    ANNOUNCEMENT_AUDIENCE_LIMIT: 'ANNOUNCEMENT_AUDIENCE_LIMIT',
    /** Story 9: konu ya da gövdede bağlantı kısaltıcı alan adı (400). */
    ANNOUNCEMENT_LINK_SHORTENER: 'ANNOUNCEMENT_LINK_SHORTENER',
    /** Story 9: kurumun e-posta duyurusu şikâyet eşiğiyle durdu ve seçili tek kanal e-posta (409). */
    ANNOUNCEMENT_EMAIL_PAUSED: 'ANNOUNCEMENT_EMAIL_PAUSED',
    /**
     * Yayın sırası kilidi (koordinatör kararı A, 17.10.2026): gönderim sunucu
     * ayarıyla (`ORGANIZER_ANNOUNCEMENTS_SEND_ENABLED`) kapalı (409). Ret sayfası
     * (T4a) ve gönder/zamanla (T3) kapanınca açılır.
     */
    ANNOUNCEMENT_SEND_DISABLED: 'ANNOUNCEMENT_SEND_DISABLED',
    /** Story 4: zamanlama anı şimdiden 10 dakikadan erken (400). */
    ANNOUNCEMENT_SCHEDULE_TOO_SOON: 'ANNOUNCEMENT_SCHEDULE_TOO_SOON',
    /** Story 4: zamanlama anı etkinlik bitişinden 30 günden sonra (400). */
    ANNOUNCEMENT_SCHEDULE_TOO_LATE: 'ANNOUNCEMENT_SCHEDULE_TOO_LATE',
    /** Story 4: yalnız zamanlanmış ya da dağıtımdaki duyuru iptal edilir (409). */
    ANNOUNCEMENT_NOT_CANCELLABLE: 'ANNOUNCEMENT_NOT_CANCELLABLE',
    /** Story 2: tek tık ret bağlantısı geçersiz, bozuk ya da sahibi yok (tek tip 404). */
    ANNOUNCEMENT_UNSUBSCRIBE_INVALID: 'ANNOUNCEMENT_UNSUBSCRIBE_INVALID',
    /**
     * Güvenlik sertleştirme 3.1: iletideki "Geri al" yalnız AYNI iletinin son
     * retini ve ret anından itibaren pencere içinde açar. Ayarlardan verilmiş ret,
     * başka iletinin reti ya da pencere dışı istek 409 alır, susturma durur.
     */
    ANNOUNCEMENT_UNSUBSCRIBE_UNDO_UNAVAILABLE: 'ANNOUNCEMENT_UNSUBSCRIBE_UNDO_UNAVAILABLE',
    /** Story 9: SES geri bildirim ucu SNS imzasını ya da konusunu doğrulayamadı (403). */
    EMAIL_FEEDBACK_REJECTED: 'EMAIL_FEEDBACK_REJECTED',
};
//# sourceMappingURL=error-codes-announcements.js.map